export const getFileName = (name) => {
  return name.replace(/\.[^/.]+$/, '');
};
